class Modal {
    constructor(readonly triggerButton: HTMLButtonElement) {
        this.mount();
    }
    private mount() {
        const foundContent = document.querySelector("#non-modal-content");

        let mainContent: HTMLDivElement;

        if (foundContent instanceof HTMLDivElement) {
            mainContent = foundContent;
            mainContent.setAttribute("aria-hidden", "true");
            mainContent.inert = true;
        }

        // Create overlay
        const overlay = document.createElement("div");
        overlay.classList.add("sa-error-modal");
        overlay.setAttribute("role", "alertdialog");
        overlay.setAttribute("aria-modal", "true");
        overlay.setAttribute("aria-labelledby", "sa-error-title");

        // Modal content container
        const modal = document.createElement("div");
        modal.className = "sa-error-modal-content";
        modal.tabIndex = -1;

        // Title
        const title = document.createElement("h2");
        title.id = "error-title";
        title.textContent = "Something Went Wrong";

        // Message
        const message = document.createElement("p");
        message.textContent =
            "An error occurred and the Student Assistant can't load correctly. Try reopening Student Assistant in a few minutes.";

        // Button
        const closeButton = document.createElement("button");
        closeButton.id = "sa-error-back-button";
        closeButton.setAttribute("aria-label", "Back to activity");
        closeButton.textContent = "Back to activity";
        closeButton.tabIndex = 0;

        closeButton.addEventListener("click", () => {
            document.body.removeChild(overlay);

            // Re-enable background content
            if (mainContent) {
                mainContent.removeAttribute("aria-hidden");
                mainContent.inert = false;
            }

            // retain focus to student assistant button
            this.triggerButton.focus();
        });

        // Assemble
        modal.appendChild(title);
        modal.appendChild(message);
        modal.appendChild(closeButton);
        overlay.appendChild(modal);

        // Mount into the DOM
        document.body.appendChild(overlay);

        // Set the focus on the close button in the error modal
        closeButton.focus();
    }
}

export { Modal };
